module.exports = __webpack_public_path__ + "static/media/bhoomiputra.7c91b5d9.png";